__turbopack_context__.v({
  "answer": "page-module__lK9RgW__answer",
  "bar": "page-module__lK9RgW__bar",
  "card": "page-module__lK9RgW__card",
  "cardLift": "page-module__lK9RgW__cardLift",
  "check-draw": "page-module__lK9RgW__check-draw",
  "checkDraw": "page-module__lK9RgW__checkDraw",
  "chevron": "page-module__lK9RgW__chevron",
  "compareOurs": "page-module__lK9RgW__compareOurs",
  "compareRow": "page-module__lK9RgW__compareRow",
  "compareTable": "page-module__lK9RgW__compareTable",
  "darkCard": "page-module__lK9RgW__darkCard",
  "details": "page-module__lK9RgW__details",
  "fade-in": "page-module__lK9RgW__fade-in",
  "fadeIn": "page-module__lK9RgW__fadeIn",
  "header": "page-module__lK9RgW__header",
  "header-away": "page-module__lK9RgW__header-away",
  "headerInner": "page-module__lK9RgW__headerInner",
  "iconTile": "page-module__lK9RgW__iconTile",
  "iconTileDark": "page-module__lK9RgW__iconTileDark",
  "litWord": "page-module__lK9RgW__litWord",
  "priceBar": "page-module__lK9RgW__priceBar",
  "prose": "page-module__lK9RgW__prose",
  "range": "page-module__lK9RgW__range",
  "revealGroup": "page-module__lK9RgW__revealGroup",
  "rim-rise": "page-module__lK9RgW__rim-rise",
  "rise": "page-module__lK9RgW__rise",
  "rise-soft": "page-module__lK9RgW__rise-soft",
  "searchField": "page-module__lK9RgW__searchField",
  "segment": "page-module__lK9RgW__segment",
  "sourceChip": "page-module__lK9RgW__sourceChip",
  "starTile": "page-module__lK9RgW__starTile",
  "stars": "page-module__lK9RgW__stars",
  "starsTwinkle": "page-module__lK9RgW__starsTwinkle",
  "storyProgress": "page-module__lK9RgW__storyProgress",
  "storyScene": "page-module__lK9RgW__storyScene",
  "storyStep": "page-module__lK9RgW__storyStep",
  "tableScroll": "page-module__lK9RgW__tableScroll",
  "tile-breathe": "page-module__lK9RgW__tile-breathe",
  "timeline": "page-module__lK9RgW__timeline",
  "timeline-fill": "page-module__lK9RgW__timeline-fill",
  "timelineDot": "page-module__lK9RgW__timelineDot",
  "tocLink": "page-module__lK9RgW__tocLink",
  "twinkle": "page-module__lK9RgW__twinkle",
  "word-lit": "page-module__lK9RgW__word-lit",
});
